<template>
  <div class="pr-wrapper">
    <div class="pr-box">
      <div class="pr-header">
        <slot name="header" />
      </div>
      <div class="pr-pane">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PR_Wrapper',
};
</script>

<style lang="less" scoped>
.pr-wrapper {
  .pr-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    border: 1px solid rgba(220, 223, 230, 1);
  }
  .pr-header {
    min-height: 51px;
    line-height: 51px;
    padding: 0 24px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(235, 238, 245, 1);
  }
  .pr-pane {
    padding: 24px;
    box-sizing: border-box;
  }
}
</style>
